// src/components/store/sections/blog-posts/BlogV102GlassauroraLimeZest.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV102GlassauroraLimeZest(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={102}
      archKey="glass_aurora"
      archLabel="Frosted Glass Stories"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
